import { Button } from '@mui/material'
import * as css from '../styles'
import { t } from '@lingui/core/macro'

interface Props {
  disabled: boolean
  onClick: () => void
}

export const ApplyButton = ({ disabled, onClick }: Props) => {
  return (
    <Button
      name="apply"
      disableElevation
      color="primary"
      variant="contained"
      css={css.button}
      onClick={onClick}
      disabled={disabled}
    >
      {t`Apply`}
    </Button>
  )
}
